import { FC } from 'react'
import type { SnackbarProps as MUISnackbarProps } from '@mui/material'
import { Alert, Paper, Snackbar as MUISnackbar } from '@mui/material'
import { styled } from '@mui/material/styles'

import { SnackType } from '../../types'

const StyledAlert = styled(Alert)(() => ({
  maxWidth: 600,
  minWidth: 300,
  maxHeight: 100,
  '& .MuiAlert-message': {
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
}))

type SnackbarProps = MUISnackbarProps & { type: SnackType; statusCode?: number }

export const Snackbar: FC<SnackbarProps> = ({ message, type, statusCode, ...props }) => {
  const status = statusCode ? `${statusCode}: ` : ''

  return (
    <MUISnackbar {...props} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
      <Paper elevation={1}>
        <StyledAlert severity={type}>{`${status}${message}`}</StyledAlert>
      </Paper>
    </MUISnackbar>
  )
}
